/**
 * @file コンポーネント：テキストフォーム DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledInput } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledInput
            {...props}
            className={props.isWide && "is-wide"}
            data-font-size={props.fontSize}
            ref={props.refInputText}
            type={props.type ? props.type : "text"}
        />
    );
};
